import { INSPECT_TYPE } from "@/model/InspectType";
import { Legal56InspectionSelectionsRouteService } from "@/model/Legal56InspectionSelectionsRouteService";
import {
  createBaseInspectionSelectionsRouteService
} from "@/service/InspectionSelectionsRouteService";
import requestService from "@/service/requestService";

/*
 * WHY: legal56 固有の API、inspectType、headerTopic、disabledSave 除外条件を
 * inspectionSelections.vue の routeName 分岐から分離する。
 */
export function createLegal56InspectionSelectionsRouteService(
  reqService: requestService
): Legal56InspectionSelectionsRouteService {
  return createBaseInspectionSelectionsRouteService({
    routeName: "legal56",
    inspectType: INSPECT_TYPE.LEGAL56,
    headerTopic: "57項目点検内容",
    apiPath: "legal56",
    reqService,
    getInspect: (uketsukeExtendsId: number) =>
      reqService.getLegal56Inspect(uketsukeExtendsId),
    getInspectByCategoryId: (
      uketsukeExtendsId: number,
      sknInspectCategoryId: number
    ) =>
      reqService.getLegal56InspectByCategoryId(
        uketsukeExtendsId,
        sknInspectCategoryId
      ),
    saveInspect: (data: any) => reqService.saveLegal56Inspect(data),
    /*
     * WHY: gensha/legal56 では未紐づけの disabledSave 整備を保存対象から外すため。
     */
    shouldRemoveUnlinkedDisabledSaveSeibi(): boolean {
      return true;
    }
  });
}
